import React from "react";
import { IConfirmationProps } from "@/interfaces/IConfirmationModal";

const UserConfirmationModal = ({ confirmationModalVariables, onLeftButtonClick, onRightButtonClick, modalClassName }: IConfirmationProps) => {
    return (
        <>
            <div className={`${modalClassName} confirmation-modal-container`}>
                <div data-testid="title" className="confirmation-modal-title">
                    {confirmationModalVariables.modalTitle}
                </div>
                <div className="confirmation-modal-question">
                    {confirmationModalVariables.confirmationQuestion}
                </div>

                <div className="confirmation-modal-buttons divider-top">
                    {confirmationModalVariables.leftButton && (
                        <button
                            className={`${confirmationModalVariables.leftButton === 'Cancel' ? "" : "button-red-highlight"} left-button`}
                            aria-label={confirmationModalVariables.leftButton}
                            onClick={onLeftButtonClick}
                        >
                            {confirmationModalVariables.leftButton}
                        </button>
                    )}

                    <button
                        className="right-button"
                        aria-label={confirmationModalVariables.rightButton}
                        onClick={onRightButtonClick}
                    >
                        {confirmationModalVariables.rightButton}
                    </button>
                </div>
            </div>
        </>
    );
};

export default UserConfirmationModal;
